export const levelTinh = { label: "Tỉnh/ Thành", value: "T" };
export const levelHuyen = { label: "Quận/ Huyện", value: "Q" };
export const levelXa = { label: "Phường/ Xã", value: "P" };
export const levelNuocNgoai = { label: "Nước ngoài", value: "NN" };
export const levelDivisions = [levelTinh, levelHuyen, levelXa, levelNuocNgoai];

export const parseLevelDivisions = (value) => {
    if (value) {
        return levelDivisions.find((e) => e.value === value)?.label;
    } else {
        return null;
    }
};
